import { Routes, Route } from "react-router-dom";
import "./App.css";
import NavBar from "./components/NavBar";
import Banner from "./components/Banner";
import BannerNew from "./components/BannerNew";
import { Footer } from "./components/Footer";
import {
  Home,
  IndustryCalls,
  OrgCommittee,
  PhDForumCalls,
  PosterCalls,
  ResearchCalls,
  TutorialCalls,
  WorkPaperCalls,
  WorkProposalCalls,
  AcceptedPapers,
  InProgress,
  TechCommittee,
  Accommodation,
  Venue,
  Workshops,
  LocalAttractions,
  Keynotes,
  NSFGrant,
  Visa,
  Registration,
  CameraReady,
  SchedulePage,
  Tutorials,
  PostersDemosForum,
} from "./components/pages";

function App() {
  return (
    <>
      <NavBar />
      <BannerNew />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/organisationcommittee" element={<OrgCommittee />} />
        <Route path="/industrycalls" element={<IndustryCalls />} />
        <Route path="/phdforumcalls" element={<PhDForumCalls />} />
        <Route path="/postercalls" element={<PosterCalls />} />
        <Route path="/researchcalls" element={<ResearchCalls />} />
        <Route path="/tutorialcalls" element={<TutorialCalls />} />
        <Route path="/workpapercalls" element={<WorkPaperCalls />} />
        <Route path="/workproposalcalls" element={<WorkProposalCalls />} />
        <Route path="/acceptedpapers" element={<AcceptedPapers />} />
        <Route path="/inprogress" element={<InProgress />} />
        <Route path="/technicalcommittee" element={<TechCommittee />} />
        <Route path="/accommodation" element={<Accommodation />} />
        <Route path="/venue" element={<Venue />} />
        <Route path="/workshops" element={<Workshops />} />
        <Route path="/localattractions" element={<LocalAttractions />} />
        <Route path="/keynotes" element={<Keynotes />} />
        <Route path="/nsfgrant" element={<NSFGrant />} />
        <Route path="/visa" element={<Visa />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/cameraready" element={<CameraReady />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/tutorials" element={<Tutorials />} />
        <Route path="/postersdemosforum" element={<PostersDemosForum />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
